export interface JoinCondition {
  left: string;
  right: string;
}

export class TransformJoinModel {
  constructor(
    public type = '',
    public left = '',
    public right = '',
    public joinConditions: JoinCondition[] = [],
    public customMapping: { [key: string]: string } = {},
  ) {}
}
